import { AnyUserEntityVersion } from '@uploadcam/common';
import { CollectionReference, doc, updateDoc } from 'firebase/firestore';

interface UpdateUserData {
  discoverySource?: string;
}

export class UpdateUserLocalInteractor {
  constructor(private readonly collection: CollectionReference<AnyUserEntityVersion>) {}

  public async execute(userId: string, data: UpdateUserData): Promise<void> {
    await updateDoc(doc(this.collection, userId), {
      ...(data.discoverySource
        ? { 'acquisitionMetadata.discoverySource': data.discoverySource }
        : {}),
    });
  }
}
